export function fileToDataURL(file, callback) {
  const reader = new FileReader()
  reader.onloadend = function onLoadEnd(event) {
    callback(event.target.result)
  }
  reader.readAsDataURL(file)
}
